export default __webpack_public_path__ + "static/media/previous-icon.36623a23.svg";